import styled from 'styled-components';
import { getGridSpan, getSpace, mq, maxContentWidth } from '../../../stylesheets/tools';

const StyledStage = styled.section`
  ${maxContentWidth('1440px')}
  width: 100%;
  margin: 0 auto ${getSpace('xxl')};
  padding-top: ${getSpace('120px')};
  position: relative;
  display: flex;
  flex-wrap: wrap;

  ${mq('m')} {
    padding-top: ${getSpace('xl')};
  }

  .outro__container .container__wrapper {
    ${mq('m')} {
      margin-bottom: ${getSpace('40px')};
    }
  }

  .outro__introduction {
    width: ${getGridSpan('11', 'normal')};
    margin: ${getSpace('m')} 0 ${getSpace('m')} ${getGridSpan('1', 'spread')};

    ${mq('m')} {
      width: ${getGridSpan('10', 'normal')};
    }
  }
`;

export default StyledStage;
